import { navigateToHeydayPage, subscribeToHeydayLocation } from '../../config/heydayRoutes';
import type { LifecycleRoutePort, LifecycleRouteState } from '../../features/lifecycle/public';

function currentState(): LifecycleRouteState {
  const parameters = new URLSearchParams(window.location.search);
  if (parameters.get('view') === 'templates') return { view: 'templates' };
  const workerId = parameters.get('worker')?.trim();
  return {
    view: 'checklists',
    onboarding: parameters.get('action') === 'onboarding' && workerId
      ? { workerId, targetOn: parameters.get('targetOn') || undefined }
      : undefined,
  };
}

export const lifecycleRouteAdapter: LifecycleRoutePort = {
  read: currentState,
  replace(view) {
    navigateToHeydayPage('lifecycle', view === 'templates' ? 'view=templates' : undefined, { replace: true });
  },
  subscribe: subscribeToHeydayLocation,
};
